import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedState,
  useDisclosure,
  useHotkeys,
  useIsFirstRender,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconCalendar,
  IconCalendarPlus,
  IconCaretDown,
  IconCheck,
  IconClipboardPlus,
  IconClipboardX,
  IconCubeSend,
  IconEdit,
  IconEye,
  IconFileExport,
  IconFileUpload,
  IconMapPinCog,
  IconPackage,
  IconPackageExport,
  IconPlus,
  IconRocket,
  IconSearch,
  IconStatusChange,
  IconTrash,
  IconTruck,
  IconTruckDelivery,
  IconTruckReturn,
  IconUserX,
  IconWriting,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_ColumnVirtualizer,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, {
  useDeferredValue,
  useEffect,
  useRef,
  useState,
  useTransition,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LoaiGv,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
  typeGv,
} from "../../../_base/_const/_constVar";
import {
  DefaultMemoizedCell,
  DefaultMemoizedCellDate,
} from "../../../_base/_const/baseHook";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import useDynamicHeight from "../../../_base/component/Core/hookBase";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { DeliveryStatusCode } from "../../../const/deliveryStatus";
import { beige, green, navy_blue, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDelivery } from "../../../model/TblDelivery";
import {
  getBranchSelectMdm,
  getDeliveryStatusSelectMdm,
} from "../../../service/getSelectApi";
import CancelGHTKAndAhamove from "./CancelGHTKAndAhamove";
import ChangeLocationV2 from "./ChangeLocationV2";
import CreateDataViewV2 from "./CreateDataViewV2";
import DeleteView from "./DeleteView";
import DeliveryAssignmentAddressNew from "./DeliveryAssignmentV2";
import DetailDataView from "./DetailDataView";
import DetailProduct from "./DetailProduct";
import EditDataViewV2 from "./EditDataViewV2";
import GHTKAndAhamove from "./GHTK&Ahamove";
import AssignmentOfInstallation from "./AssignmentOfInstallation";
import ExtendDeliveryTime from "./ExtendDeliveryTime";
// Ensure this file exists at the specified path or update the path to the correct location

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const Delivery2 = () => {
  const [valueTypeGet, setValueTypeGet] = useState<string>("");
  // Reference data from another table
  const navigate = useNavigate();
  const [dataTblDeliveryStatusSelect, setDataTblDeliveryStatusSelect] =
    useState<ComboboxItem[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<any[]>([]);
  const [dataDeliverySelect, setDataDeliverySelect] = useState<any[]>([]);

  const bankOptions = [
    { label: "Vietcombank", value: "1" },
    { label: "VietinBank", value: "2" },
    {
      label: "Agribank",
      value: "3",
    },
    { label: "BIDV", value: "4" },
    { label: "Techcombank", value: "5" },
    { label: "ACB", value: "6" },
    { label: "Sacombank", value: "7" },
    { label: "SHB", value: "8" },
    { label: "MB Bank", value: "9" },
    { label: "Eximbank", value: "10" },
    { label: "VPBank", value: "11" },
    { label: "HDBank", value: "12" },
    { label: "TPBank", value: "13" },
    { label: "LienVietPostBank", value: "14" },
    { label: "SeABank", value: "15" },
    { label: "VIB", value: "16" },
    { label: "MSB", value: "17" },
    { label: "SCB", value: "18" },
    { label: "OCB", value: "19" },
    { label: "DongA Bank", value: "20" },
  ];

  const dataShippingUnit = [
    { label: "Nội bộ", value: "1" },
    { label: "GHTK", value: "3" },
    { label: "Ahamove", value: "2" },
  ];
  const isPackTheGoods = [
    { label: "Đã đóng gói", value: "DA_DONG_GOI" },
    { label: "Không đóng gói", value: "KHONG_DONG_GOI" },
  ];
  const firstRender = useIsFirstRender();
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDelivery[]>([]);
  const [dataTemp, setDataTemp] = useState<TblDelivery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [toPageDetail, setToPageDetail] = useState(false);
  const [toPageEdit, setToPageEdit] = useState(false);
  const [toPageCreate, setToPageCreate] = useState(false);
  //table state
  const [rowCount, setRowCount] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15,
  });
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [productDetails, setProductDetails] = useState({
    id: "",
    sourceType: 0,
    sourceCode: "",
  });
  //  const [opened, { open, close }] = useDisclosure(false);
  const [orderCode, setOrderCode] = useState("");

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );
  const [search, setSearch] = useState({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setDate(new Date().getDate() - 2)).getTime() +
              7 * 60 * 60 * 1000,
          ).toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    deliveryDepartmentId:
      _searchJson && checkedPinSearch ? _searchJson?.deliveryDepartmentId : "",
    statusId: _searchJson && checkedPinSearch ? _searchJson?.statusId : [],
    branchId: _searchJson && checkedPinSearch ? _searchJson?.branchId : [],
    customerId: _searchJson && checkedPinSearch ? _searchJson?.customerId : "",
    customerProvinceId:
      _searchJson && checkedPinSearch ? _searchJson?.customerProvinceId : "",
    customerDistrictId:
      _searchJson && checkedPinSearch ? _searchJson?.customerDistrictId : "",
    customerCommuneId:
      _searchJson && checkedPinSearch ? _searchJson?.customerCommuneId : "",
    type: _searchJson && checkedPinSearch ? _searchJson?.type : "",
    empid: _searchJson && checkedPinSearch ? _searchJson?.empid : "",
    sourceType: _searchJson && checkedPinSearch ? _searchJson?.sourceType : [],
    sourceCode: _searchJson && checkedPinSearch ? _searchJson?.sourceCode : "",
    transactionNumber:
      _searchJson && checkedPinSearch ? _searchJson?.transactionNumber : "",
    shippingUnit:
      _searchJson && checkedPinSearch ? _searchJson?.shippingUnit : "",
    attribute47:
      _searchJson && checkedPinSearch ? _searchJson?.attribute47 : false,
    isPackage: _searchJson && checkedPinSearch ? _searchJson?.isPackage : "",
  });

  // Giữ giá trị tìm kiếm mới nhất để fetchData không bị dính closure cũ
  // (fetchData được truyền vào các cell đã memo / modal nên dễ giữ state cũ)
  const latestSearchRef = useRef({
    search,
    keySearch,
    pagination,
    valueTypeGet,
  });

  useEffect(() => {
    latestSearchRef.current = { search, keySearch, pagination, valueTypeGet };
  }, [search, keySearch, pagination, valueTypeGet]);

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 2, xl: 2 };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "createDate",
        header: "Ngày lập",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
        size: 140,
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh yêu cầu",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "fromBranchName",
        header: "Chi nhánh đi",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "sourceCode",
        header: "Số chứng từ gốc",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue && renderedCellValue !== null ? (
            String(row.original.attribute47) === "1" ||
            String(row.original.shippingPriority) === "1" ? (
              <Badge
                radius="sm"
                leftSection={<IconRocket size={14} />}
                size="md"
                color={"red"}
                onDoubleClick={() => {
                  if (renderedCellValue?.toString()?.includes("DH")) {
                    handleCheckView(row);
                  } else {
                    return;
                  }
                }}
              >
                {renderedCellValue}
              </Badge>
            ) : (
              <Badge
                radius="sm"
                variant="dot"
                size="md"
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() => {
                  if (renderedCellValue?.toString()?.includes("DH")) {
                    handleCheckView(row);
                  } else {
                    return;
                  }
                }}
              >
                {renderedCellValue}
              </Badge>
            )
          ) : (
            <></>
          ),
        enableColumnFilter: false,
        size: 160,
      },
      {
        accessorKey: "toAddress",
        header: "Địa chỉ giao hàng",
        Cell: ({ row }) => (
          <Text fw={500} size="11.5px">
            {row.original.toAddress?.replace(/^(undefined|null) - /, "")}
          </Text>
        ),
        enableColumnFilter: false,
        size: 550,
      },
      {
        accessorKey: "description",
        header: "Ghi chú đơn hàng",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "transactionStatus",
        header: "Trạng thái chứng từ gốc",
        size: 210,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "debt",
        header: "Công nợ",
        Cell: ({ row }) => (
          <Text fw={500} size="11.5px">
            {row.original.sourceType === 1 && row.original.debt === null
              ? "Thu tiền ngay"
              : row.original.debt}
          </Text>
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "createByName",
        header: "Nhân viên tạo đơn hàng",
        // Cell: ({ renderedCellValue }) => (
        //   <AvatarUtils
        //     value={renderedCellValue?.toString() ?? ""}
        //     sizeXS={true}
        //   />
        // ),
        enableColumnFilter: false,
        size: 225,
      },
      {
        accessorKey: "amountTotal",
        header: "Tiền phải thu",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue && renderedCellValue !== "0"
              ? `${Number(renderedCellValue)?.toLocaleString()} đ`
              : "0 đ"}
          </>
        ),
      },
      {
        accessorKey: "paymentCash",
        header: "Tiền mặt đã trả",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue && renderedCellValue !== "0"
              ? `${Number(renderedCellValue)?.toLocaleString()} đ`
              : "0 đ"}
          </>
        ),
      },
      {
        accessorKey: "paymentBankTransfer",
        header: "Chuyển khoản",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue && renderedCellValue !== "0"
              ? `${Number(renderedCellValue)?.toLocaleString()} đ`
              : "0 đ"}
          </>
        ),
      },
      {
        accessorKey: "cardPaymentAmount",
        header: "Thẻ ATM",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue && renderedCellValue !== "0"
              ? `${Number(renderedCellValue)?.toLocaleString()} đ`
              : "0 đ"}
          </>
        ),
      },
      {
        accessorKey: "amountRemaining",
        header: "Tiền còn lại",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, row }) => {
          const amount =
            Number(renderedCellValue) - Number(row.original.attribute60);

          return <>{`${Number(amount)?.toLocaleString()} đ`}</>;
        },
      },
      {
        accessorKey: "bankAccountId",
        header: "Ngân hàng",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <>
            {getValueById(
              renderedCellValue?.toString() ?? "",
              bankOptions,
              "label",
            )}
          </>
        ),
      },
      // {
      //   accessorKey: "attribute23",
      //   header: "Tổng tiền đơn hàng",
      //   enableColumnFilter: false,
      //   Cell: ({ renderedCellValue, row }) => (
      //     <>
      //       {renderedCellValue && renderedCellValue !== "0"
      //         ? `${Number(renderedCellValue)?.toLocaleString()} đ`
      //         : "0 đ"}
      //     </>
      //   ),
      // },
      // {
      //   accessorKey: "attribute30",
      //   header: "Tổng tiền kế toán đã thu",
      //   enableColumnFilter: false,
      //   Cell: ({ renderedCellValue, row }) => (
      //     <>
      //       {renderedCellValue && renderedCellValue !== "0"
      //         ? `${Number(renderedCellValue)?.toLocaleString()} đ`
      //         : "0 đ"}
      //     </>
      //   ),
      // },
      {
        accessorKey: "deliveryStatusName",
        header: "Trạng thái đơn giao hàng",
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={getColorStatus(renderedCellValue?.toString() ?? "")}
            radius={"sm"}
            size="xs"
          >
            {renderedCellValue}
          </Badge>
        ),
        size: 210,
        enableColumnFilter: false,
      },
      {
        accessorKey: "sourceType",
        header: "Nguồn hàng",
        Cell: ({ row }) => (
          <Badge
            color={getColorSourceType(row.original.sourceType)}
            radius={"sm"}
            size="xs"
          >
            {soureTypeText(row.original.sourceType)}
          </Badge>
        ),
        enableColumnFilter: false,
        size: 140,
      },
      {
        accessorKey: "subInvName",
        header: "Kho",
        enableColumnFilter: false,
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "customerName",
        header: "Khách hàng",
        size: 140,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "telephoneNumber",
        header: "Số điện thoại",
        enableColumnFilter: false,
        size: 140,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "responsibleEmployeeName",
        header: "Nhân viên giao hàng",
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
        enableColumnFilter: false,
        size: 200,
      },
      {
        accessorKey: "transactionNumber",
        header: "Số giao dịch",
        Cell: ({ renderedCellValue, row }) =>
          String(row.original.attribute47) === "1" ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                leftSection={<IconRocket size={14} />}
                size="xs"
                style={{ cursor: "pointer" }}
                color={"red"}
                onDoubleClick={() => detailItem(row.original.id)}
              >
                {renderedCellValue === null ? null : renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="xs"
                style={{ cursor: "pointer" }}
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() => detailItem(row.original.id)}
              >
                {renderedCellValue === null ? null : renderedCellValue}
              </Badge>
            </Tooltip>
          ),
        enableColumnFilter: false,
        size: 140,
      },
      {
        accessorKey: "attribute11",
        header: "Công việc",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "attribute4",
        header: "Đơn vị vận chuyển",
        size: 200,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge color={renderedCellValue === "GHTK" ? "#00EE36" : "#FF7F32"}>
              {renderedCellValue}
            </Badge>
          ) : (
            <Badge
              variant="gradient"
              gradient={{ from: "#EA242A", to: "#2B3276", deg: 90 }}
            >
              Nội bộ
            </Badge>
          ),
      },
      // {
      //   accessorKey: "isPackage",
      //   header: "Tình trạng đóng gói",
      //   Cell: ({ renderedCellValue }) => (
      //     <Text fw={500} size="12.5px">
      //       {getValueById(
      //         String(renderedCellValue || ""),
      //         isPackTheGoods,
      //         "label",
      //       )}
      //     </Text>
      //   ),
      // },
      {
        accessorKey: "attribute46",
        header: "Trạng thái giao hàng (GV bên thứ 3)",
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={getColorStatus(
              getValueById(
                renderedCellValue?.toString() ?? "",
                dataTblDeliveryStatusSelect,
                "label",
              ),
            )}
            radius={"sm"}
            size="xs"
          >
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataTblDeliveryStatusSelect,
              "label",
            )}
          </Badge>
        ),
        size: 275,
        enableColumnFilter: false,
      },
      {
        accessorKey: "invoiceDate",
        header: "Ngày duyệt đơn",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "transactionFinishDate",
        header: "Ngày xuất kho",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "deliveryAppointmentTime",
        header: "Ngày hẹn giao",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "extendToDate",
        header: "Ngày gia hạn thêm",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "receptionTime",
        header: "Ngày tiếp nhận",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "deliveryTime",
        header: "Ngày giao hàng",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "arrivalTime",
        header: "Ngày đến nơi",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "completionTime",
        header: "Ngày hoàn thành",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute15",
        header: "BPGV",
        enableColumnFilter: false,
      },
      {
        accessorKey: "transactionContent",
        header: "Nội dung giao",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "attribute2",
        header: "Ghi chú nhân viên giao hàng",
        enableColumnFilter: false,
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
        enableResizing: false,
        enableClickToCopy: false,
        size: 225,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {(row.original.deliveryStatusName === "Lập đơn giao hàng" ||
              row.original.deliveryStatusName === "Hủy phân công" ||
              row.original.deliveryStatusName === "Đã phân công") && (
              <Tooltip label="Gia hạn thời gian giao hàng">
                <ActionIcon
                  variant="light"
                  size={"xs"}
                  onClick={() => modalExtendDeliveryTime(row.original)}
                >
                  <IconCalendarPlus size={"xs"} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            )}
            {(row.original.statusId === DeliveryStatusCode.TAO_MOI ||
              row.original.statusId === DeliveryStatusCode.HUY_PHAN_CONG) && (
              <Tooltip label="Điều chỉnh bộ phận">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="violet"
                  size={"xs"}
                  disabled={valueTypeGet === "5"}
                  onClick={async () => {
                    if (
                      row.original.statusId !== DeliveryStatusCode.TAO_MOI &&
                      row.original.statusId !== DeliveryStatusCode.HUY_PHAN_CONG
                    ) {
                      NotificationExtension.Fails(
                        "Chỉ đổi được với trạng thái Lập đơn giao hàng !",
                      );
                      return;
                    }
                    modals.openConfirmModal({
                      title: "Điều chỉnh bộ phận !",
                      children: (
                        <>
                          <UpdateDepartment
                            data={row.original}
                            load={fetchData}
                          />
                        </>
                      ),
                      labels: { confirm: "Confirm", cancel: "Cancel" },
                      onCancel: () => console.log("Cancel"),
                      onConfirm: () => console.log("Confirmed"),
                      confirmProps: { display: "none" },
                      cancelProps: { display: "none" },
                    });
                  }}
                >
                  <IconWriting size={"xs"} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            )}
            {!(
              row.original.statusId !== DeliveryStatusCode.TAO_MOI &&
              row.original.statusId !== DeliveryStatusCode.HUY_PHAN_CONG &&
              row.original.statusId !== DeliveryStatusCode.THAT_BAI_DO_KH &&
              row.original.statusId !== DeliveryStatusCode.THAT_BAI_DO_HACOM &&
              row.original.statusId !== DeliveryStatusCode.NOI_CHUYEN
            ) && (
              <>
                <Menu shadow="md" width={200}>
                  <Menu.Target>
                    <Tooltip label="Chỉnh sửa vị trí">
                      <ActionIcon
                        variant="light"
                        aria-label="Settings"
                        color="blue"
                        size={"xs"}
                        disabled={valueTypeGet === "5"}
                      >
                        <IconMapPinCog size={"xs"} stroke={1.5} />
                      </ActionIcon>
                    </Tooltip>
                  </Menu.Target>

                  <Menu.Dropdown>
                    {(row.original.statusId === DeliveryStatusCode.TAO_MOI ||
                      row.original.statusId ===
                        DeliveryStatusCode.NOI_CHUYEN) && (
                      <Menu.Item
                        leftSection={
                          <IconUserX
                            style={{ width: rem(14), height: rem(14) }}
                          />
                        }
                        onClick={() =>
                          // changeLocation(
                          //   row.original.id,
                          //   row.original.customerProvinceId,
                          //   row.original.customerDistrictId,
                          //   row.original.customerCommuneId,
                          //   row.original.streetId,
                          //   row.original.customerAddress,
                          //   row.original.statusId,
                          //   row.original.attribute28,
                          //   1
                          // )
                          changeLocationV2(
                            row.original.id,
                            0,
                            0,
                            "",
                            row.original.statusId,
                            row.original.attribute28,
                            1,
                          )
                        }
                      >
                        Điểm đi
                      </Menu.Item>
                    )}

                    <Menu.Item
                      leftSection={
                        <IconClipboardX
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                      onClick={() =>
                        // changeLocation(
                        //   row.original.id,
                        //   row.original.customerProvinceId,
                        //   row.original.customerDistrictId,
                        //   row.original.customerCommuneId,
                        //   row.original.streetId,
                        //   row.original.customerAddress,
                        //   row.original.statusId,
                        //   row.original.attribute28,
                        //   2
                        // )
                        changeLocationV2(
                          row.original.id,
                          row.original.customerProvinceId,
                          row.original.customerCommuneId,
                          row.original.customerAddress
                            ? row.original.customerAddress
                            : row.original.attribute3,
                          row.original.statusId,
                          row.original.attribute28,
                          2,
                        )
                      }
                    >
                      Điểm đến
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </>
            )}
            {!(
              (row.original.statusId !== 1 && row.original.statusId !== 8) ||
              row.original.sourceType !== 3
            ) && (
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="orange"
                  size={"xs"}
                  disabled={valueTypeGet === "5"}
                  onClick={async () => {
                    editItem(row.original.id);
                  }}
                  // disabled={
                  //   (row.original.statusId !== 1 &&
                  //     row.original.statusId !== 8) ||
                  //   row.original.sourceType !== 3
                  // }
                >
                  <IconEdit size={"xs"} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            )}
            <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                size={"xs"}
                onClick={async () => {
                  detailItem(row.original.id);
                }}
              >
                <IconEye size={"xs"} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            {((row.original.sourceType === 1 &&
              row.original.customerProvinceId === 3 &&
              row.original.fromAddress
                ?.toString()
                ?.toLowerCase()
                ?.includes("hà nội")) ||
              (row.original.sourceType === 1 &&
                row.original.customerProvinceId === 29 &&
                row.original.fromAddress
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes("hồ chí minh")) ||
              (row.original.sourceType === 2 &&
                row.original?.fromAddress
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes("hà nội") &&
                row.original?.toAddress
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes("hà nội")) ||
              (row.original.sourceType === 2 &&
                row.original?.fromAddress
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes("hồ chí minh") &&
                row.original?.toAddress
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes("hồ chí minh"))) &&
            (row.original.deliveryStatusName === "Lập đơn giao hàng" ||
              row.original.deliveryStatusName === "Hủy phân công") &&
            !row.original.attribute4 ? (
              <>
                <Tooltip label="Điều chuyển đơn vị giao hàng">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="green"
                    size={"xs"}
                    disabled={valueTypeGet === "5"}
                    onClick={() => modalsGHTKAhamove(row.original)}
                  >
                    <IconCubeSend />
                  </ActionIcon>
                </Tooltip>
              </>
            ) : (
              <></>
            )}
            {row.original.attribute4 && row.original.attribute46 !== "261" ? (
              <></>
            ) : (
              <>
                {row.original.deliveryStatusName !== "Lập đơn giao hàng" &&
                  !row.original.attribute4 && (
                    <Tooltip label="Hủy phân công">
                      <ActionIcon
                        variant="light"
                        color="red"
                        size={"xs"}
                        onClick={() =>
                          modalCheckCancel([row.original.id], "HUY_PHAN_CONG")
                        }
                        disabled={
                          row.original.deliveryStatusName ===
                            "Lập đơn giao hàng" || valueTypeGet === "5"
                        }
                      >
                        <IconUserX size={"xs"} stroke={1.5} />
                      </ActionIcon>
                    </Tooltip>
                  )}
                {row.original.attribute4 === "GHTK" &&
                row.original.attribute46 === "261" ? (
                  <Tooltip label="Hủy đơn GHTK">
                    <ActionIcon
                      variant="light"
                      color="red"
                      size={"xs"}
                      disabled={valueTypeGet === "5"}
                      onClick={() =>
                        modalsCancelGHTKAndAhamove(
                          "GHTK",
                          row.original.sourceCode,
                        )
                      }
                    >
                      <IconClipboardX size={"xs"} stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>
                ) : row.original.attribute4 === "Ahamove" &&
                  row.original.attribute46 === "261" ? (
                  <Tooltip label="Hủy đơn Ahamove">
                    <ActionIcon
                      variant="light"
                      color="red"
                      size={"xs"}
                      disabled={valueTypeGet === "5"}
                      onClick={() =>
                        modalsCancelGHTKAndAhamove(
                          "Ahamove",
                          row.original.sourceCode,
                        )
                      }
                    >
                      <IconClipboardX size={"xs"} stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>
                ) : !row.original.attribute4 ? (
                  <Tooltip label="Hủy đơn hàng">
                    <ActionIcon
                      variant="light"
                      color="red"
                      size={"xs"}
                      disabled={valueTypeGet === "5"}
                      onClick={() =>
                        modalCheckCancel([row.original.id], "HUY_DON")
                      }
                    >
                      <IconClipboardX size={"xs"} stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            )}
            {!(
              (row.original.statusId !== 1 && row.original.statusId !== 8) ||
              row.original.sourceType !== 3
            ) && (
              <Tooltip label="Xóa">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="red"
                  size={"xs"}
                  disabled={valueTypeGet === "5"}
                  onClick={async () => {
                    await deleteData([row.original.id]);
                    // close();
                  }}
                  // disabled={
                  //   (row.original.statusId !== 1 &&
                  //     row.original.statusId !== 8) ||
                  //   row.original.sourceType !== 3
                  // }
                >
                  <IconTrash size={"xs"} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            )}
          </Box>
        ),
      },
    ],
    [deleteViewStatus, valueTypeGet, dataTblDeliveryStatusSelect],
  );

  useEffect(() => {
    setDefault();
    if (firstRender) {
      fetchDataBranchSelect();
    }
    // console.log(dataBranchSelect);
  }, []);

  const UpdateDepartment = ({ data, load }: { data: any; load: any }) => {
    const [value, setValue] = useState(data?.attribute15 || "");
    return (
      <>
        <Select
          label="Bộ phận giao vận"
          placeholder="Bộ phận giao vận"
          data={[
            ...LoaiGv,
            {
              label: "Kho",
              value: "KHO",
              disabled:
                data?.transactionStatus !== "Chưa xuất" ||
                String(data?.sourceType) !== "2",
            },
          ]}
          value={value}
          onChange={(e) => setValue(e ?? "")}
        />
        <Group justify="end">
          <Button
            mt={10}
            onClick={async () => {
              if (!value) {
                NotificationExtension.Fails("Bộ phận cập nhật sai !");
                return;
              }

              if (value === "KHO") {
                const changeDeliveryRequestTransfer = await repositoryMdm.get<
                  MessageResponse<any>
                >(
                  `/api/v1/TblRequestTransfer/update-attribute1?SourceCode=${data?.sourceCode}&Attribute1=KHO`,
                );

                if (
                  changeDeliveryRequestTransfer &&
                  changeDeliveryRequestTransfer.success
                ) {
                  const res = await repositoryDelivery.get<
                    MessageResponse<boolean>
                  >(
                    `/api/v1/TblDelivery/update-deparment?id=${data?.id}&department=${value}`,
                  );
                  if (res && res.success) {
                    if (res.success) {
                      fetchData();
                      modals.closeAll();
                      NotificationExtension.Success(
                        "Cập nhật bộ phận cập nhật thành công !",
                      );
                    } else
                      NotificationExtension.Fails(
                        "Cập nhật bộ phận cập nhật thất bại !",
                      );
                  }
                }
              } else {
                const res = await repositoryDelivery.get<
                  MessageResponse<boolean>
                >(
                  `/api/v1/TblDelivery/update-deparment?id=${data?.id}&department=${value}`,
                );
                if (res && res.success) {
                  if (res.success) {
                    fetchData();
                    modals.closeAll();
                    NotificationExtension.Success(
                      "Cập nhật bộ phận cập nhật thành công !",
                    );
                  } else
                    NotificationExtension.Fails(
                      "Cập nhật bộ phận cập nhật thất bại !",
                    );
                }
              }
            }}
          >
            Lưu lại
          </Button>
        </Group>
      </>
    );
  };

  const setDefault = async () => {
    if (
      _searchJson &&
      checkedPinSearch &&
      String(_searchJson?.valueTypeGet)?.length > 0
    ) {
      setValueTypeGet(_searchJson?.valueTypeGet);
    } else {
      const res = await repositoryDelivery.get<MessageResponse<string>>(
        `/api/v1/TblDelivery/get-default-gv?type=VD`,
      );
      if (res && res.success) {
        // await fetchData(res.data);
        setValueTypeGet(res?.data ? res?.data : "1");

        // startTransition(() => {
        //   setValueTypeGet(res.data);
        // });
      }
    }
  };
  function getColorSourceType(value: number) {
    switch (value) {
      case 1:
        return beige.base;
      case 2:
        return sky_blue.light_alt;
      case 3:
        return navy_blue.base;
      case 4:
        return "#7b2eda";
      case 5:
        return "#C91A52";
    }
  }

  function getColorStatus(value: string) {
    switch (value) {
      case "Đã phân công":
        return "lime";
      case "Lập đơn giao hàng":
        return "green";
      case "Đang giao hàng":
        return "teal";
      case "Đơn hàng giao chưa thành công do Khách hàng":
        return "blue";
      case "Đơn hàng giao chưa thành công do Hacom":
        return "indigo";
      case "Hàng đã giao":
        return "violet";
      case "Hủy phân công":
        return "red";
      case "Đã đến nơi":
        return "#2bdd66";
      case "Nối chuyến":
        return "yellow";
      case "Hủy đơn":
        return "#c91a25";
      case null:
      case "":
      case undefined:
        return "rgba(0, 0, 0, 0)";
    }
  }

  const soureTypeText = (numberST: number) => {
    switch (numberST) {
      case 1:
        return "Đơn hàng";
      case 2:
        return "Điều chuyển";
      case 3:
        return "Khác";
      case 4:
        return "Xuất bảo hành";
      case 5:
        return "Xuất trả khách";
    }
  };

  const getColumnVisibility = (type: string) => {
    if (type === "5") {
      return {
        id: false,
        attribute15: true,
      };
    } else {
      return {
        id: false,
        attribute15: false,
      };
    }
  };

  const detailProduct = (
    id: string,
    sourceType: number,
    sourceCode: string,
  ) => {
    if (!toPageCreate && !toPageDetail && !toPageEdit) {
      setProductDetails({ id, sourceType, sourceCode });
      //  open();
    } else {
      return;
    }
  };

  function modalDeliveryAssignment(typeDelivery: string, dataSelect?: any[]) {
    modals.openConfirmModal({
      title: (
        <>
          {selectIds.length > 1 && typeDelivery === "GIAO_HANG" ? (
            <Title order={5}>Phân công giao nhận (nhiều đơn)</Title>
          ) : typeDelivery === "NOI_CHUYEN" ? (
            <Title order={5}>Phân công nối chuyến</Title>
          ) : typeDelivery === "GHEP_DON" ? (
            <Title order={5}>Phân công ghép đơn</Title>
          ) : typeDelivery === "DONG_GOI" ? (
            <Title order={5}>Phân công đóng gói</Title>
          ) : (
            <Title order={5}>Phân công giao hàng</Title>
          )}
        </>
      ),
      size: typeDelivery === "DONG_GOI" ? "45%" : "90%",
      children:
        valueTypeGet !== "4" ? (
          <DeliveryAssignmentAddressNew
            dataDeliverySelect={dataSelect || dataDeliverySelect}
            onClose={setDeleteViewStatus}
            department={valueTypeGet}
            typeDelivery={typeDelivery}
          />
        ) : (
          <AssignmentOfInstallation
            dataDeliverySelect={dataSelect || dataDeliverySelect}
            onClose={setDeleteViewStatus}
            typeDelivery={typeDelivery}
            department={valueTypeGet}
          />
        ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const modalExtendDeliveryTime = async (data: any) => {
    modals.openConfirmModal({
      title: <Title order={5}>Gia hạn thời gian giao hàng</Title>,
      size: "auto",
      children: <ExtendDeliveryTime data={data} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const changeLocationV2 = (
    id: any,
    province: number,
    commune: number,
    addr: string,
    deliveryStatus: number,
    branchId: number,
    type: number, // 1 là thay đổi điểm đi, 2 là tháy đổi điểm đến
  ) => {
    modals.openConfirmModal({
      title: (
        <Title order={5}>
          {type === 1 ? "Chỉnh sửa điểm đi" : "Chỉnh sửa điểm đến"}
        </Title>
      ),
      size: "auto",
      children: (
        <ChangeLocationV2
          id={id}
          province={province}
          commune={commune}
          addr={addr}
          deleteViewStatus={setDeleteViewStatus}
          deliveryStatus={deliveryStatus}
          typeAddr={type}
          branchId={branchId}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalCheckCancel = (id: any, type: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>
            {type === "HUY_PHAN_CONG" ? "Hủy phân công" : "Hủy đơn"}
          </Title>
        </>
      ),
      size: "auto",
      children: (
        <Box>
          <Text fw={500} mt={10}>
            Bạn có chắc muốn{" "}
            {type === "HUY_PHAN_CONG"
              ? "hủy phân công đơn hàng"
              : "hủy đơn hàng"}{" "}
            này ?
          </Text>
          <Flex justify={"end"} gap={"md"} mt={10}>
            <Button
              color="green"
              variant="outline"
              leftSection={<IconCheck size={14} />}
              onClick={() => handleCancelDelivery(id, type)}
            >
              Xác nhận
            </Button>
          </Flex>
        </Box>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsCancelGHTKAndAhamove = (type: string, sourceCode: string) => {
    modals.openConfirmModal({
      title: (
        <Title order={5}>
          {type === "GHTK" ? "Hủy đơn GHTK" : "Hủy đơn Ahamove"}
        </Title>
      ),
      size: "auto",
      children: (
        <CancelGHTKAndAhamove
          type={type}
          sourceCode={sourceCode}
          onSuccess={setDeleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsGHTKAhamove = (data: any) => {
    modals.openConfirmModal({
      title: <Title order={5}>Chuyển đơn giao hàng sang bên GV thứ 3</Title>,
      size: "auto",
      children: (
        <GHTKAndAhamove
          data={data}
          onSuccess={fetchData}
          typeGet={valueTypeGet}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const checkAtt6 = () => {
    const check = dataDeliverySelect?.filter(
      (item) =>
        item.deliveryStatusName?.toString() === "Nối chuyến" &&
        (item.attribute6?.toString() === "FALSE" || item.attribute6 === null),
    );

    if (check.length === 0) {
      return true;
    }

    return false;
  };

  const handleTransfer = () => {
    const check = dataDeliverySelect?.filter(
      (item) =>
        item.attribute6?.toString() === "FALSE" || item.attribute6 === null,
    );

    if (check.length === 0) {
      return true;
    }

    return false;
  };

  const handleCreate = () => {
    setToPageCreate(!toPageCreate);
    //    close();
    setDeleteViewStatus((prev) => !prev);
  };

  const handleDetail = () => {
    setToPageDetail(!toPageDetail);
    // close();
    setDeleteViewStatus((prev) => !prev);
  };

  const handleEdit = () => {
    setToPageEdit(!toPageEdit);
    //   close();
    setDeleteViewStatus((prev) => !prev);
  };

  function detailItem(id: string | number) {
    // setDetailViewId(id);
    // handleDetail();
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xem chi tiết !</Title>
        </>
      ),
      size: "auto",
      children: <DetailDataView id={id} handleDetail={handleDetail} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: string | number) {
    // setEditViewId(id);
    // handleEdit();
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa !</Title>
        </>
      ),
      size: "auto",
      // children: <EditDataView id={id} handleEdit={handleEdit} />,
      children: <EditDataViewV2 id={id} handleEdit={handleEdit} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.sourceCode}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.sourceCode.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.sourceCode,
            orderType: row.original.orderType,
            actionType: "view",
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.sourceCode,
            orderType: row.original.orderType,
            actionType: "view",
          },
        });
      }
    }
  };
  const [isPending, startTransition] = useTransition();

  const handleChangeSearchValue = (value: string | string[], key: string) => {
    startTransition(() => {
      if (value !== "Invalid date")
        setSearch((prevData) => ({ ...prevData, [key]: value }));
      else {
        setSearch((prevData) => ({ ...prevData, [key]: "" }));
      }
    });
  };

  const optionColorsAccount: Record<
    | "Đã phân công"
    | "Lập đơn giao hàng"
    | "Đang giao hàng"
    | "Đã đến nơi"
    | "Đơn hàng giao chưa thành công do Khách hàng"
    | "Đơn hàng giao chưa thành công do Hacom"
    | "Hàng đã giao"
    | "Hàng đã giao - nối chuyến"
    | "Hủy phân công"
    | "Nối chuyến"
    | "Hủy đơn",
    string
  > = {
    "Đã phân công": "lime",
    "Lập đơn giao hàng": "green",
    "Đang giao hàng": "teal",
    "Đã đến nơi": "cyan",
    "Đơn hàng giao chưa thành công do Khách hàng": "blue",
    "Đơn hàng giao chưa thành công do Hacom": "indigo",
    "Hàng đã giao": "violet",
    "Hàng đã giao - nối chuyến": "grape",
    "Hủy phân công": "red",
    "Hủy đơn": "#c91a25",
    "Nối chuyến": "yellow",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as
              | "Đã phân công"
              | "Lập đơn giao hàng"
              | "Đang giao hàng"
              | "Đã đến nơi"
              | "Đơn hàng giao chưa thành công do Khách hàng"
              | "Đơn hàng giao chưa thành công do Hacom"
              | "Hàng đã giao"
              | "Hàng đã giao - nối chuyến"
              | "Hủy phân công"
              | "Hủy đơn"
              | "Nối chuyến"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorSourceType: Record<
    "Đơn hàng" | "Điều chuyển" | "Khác" | "Xuất bảo hành" | "Xuất trả khách",
    string
  > = {
    "Đơn hàng": "#E2E2B6",
    "Điều chuyển": "#6EACDA",
    Khác: "#03346E",
    "Xuất bảo hành": "#7b2eda",
    "Xuất trả khách": "#C91A52",
  };

  const renderSelectOptionSourceType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorSourceType[
            option.label as
              | "Đơn hàng"
              | "Điều chuyển"
              | "Khác"
              | "Xuất bảo hành"
              | "Xuất trả khách"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorShippingUnit: Record<"Nội bộ" | "GHTK" | "Ahamove", string> =
    {
      "Nội bộ": "linear-gradient(90deg, #EA242A 0%, #2B3276 100%)",
      GHTK: "#00EE36",
      Ahamove: "#FF7F32",
    };

  const renderSelectOptionShippingUnit: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorShippingUnit[option.label as "Nội bộ" | "GHTK" | "Ahamove"]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const deleteData = async (ids: (string | number)[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Xóa đơn hàng!</Title>
            </>
          ),
          size: "550px",
          children: <DeleteView idItems={ids} onClose={setDeleteViewStatus} />,
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const dataDeliveryStatusSelect = async () => {
    try {
      const getData = await getDeliveryStatusSelectMdm();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblDeliveryStatusSelect(mappedData);
    } catch (error) {
      console.error("Error in dataDeliveryStatusSelect: ", error);
    }
  };

  const fetchDataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataBranchSelect(
      getData.filter((item) => item.value && item.text && item.value !== "-1"),
    );
  };

  useHotkeys([
    [
      "F11",
      () => {
        handleCreate();
      },
    ],
  ]);

  const fetchData = async (typeGet?: string, noti?: string) => {
    // if (!valueTypeGet) {
    //   NotificationExtension.Fails("Vui lòng chọn bộ phận !");
    //   return;
    // }
    const {
      search: searchLatest,
      keySearch: keySearchLatest,
      pagination: paginationLatest,
      valueTypeGet: valueTypeGetLatest,
    } = latestSearchRef.current;

    setIsLoading(true);
    setIsRefetching(true);
    startTransition(() => {
      setIsError(false);
      setData([]);
      setRowCount(0);
    });
    let url = `?Skip=${
      paginationLatest?.pageIndex * paginationLatest?.pageSize
    }&Take=${paginationLatest.pageSize}`;

    if (searchLatest.startDate) {
      url += `&StartDate=${searchLatest.startDate}`;
    }

    if (searchLatest.endDate) {
      url += `&EndDate=${searchLatest.endDate}`;
    }

    if (searchLatest.statusId.length > 0) {
      url += searchLatest.statusId
        .map((item: any) => `&StatusId=${item}`)
        .join("");
    }

    if (searchLatest.branchId.length > 0) {
      url += searchLatest.branchId
        .map((item: any) => `&BranchId=${item}`)
        .join("");
    }

    if (searchLatest.customerId) {
      url += `&CustomerId=${searchLatest.customerId}`;
    }

    if (searchLatest.sourceType.length > 0) {
      url += searchLatest.sourceType
        .map((item: any) => `&SourceType=${item}`)
        .join("");
    }

    if (searchLatest.sourceCode) {
      url += `&SourceCode=${searchLatest.sourceCode}`;
    }

    if (searchLatest.transactionNumber) {
      url += `&TransactionNumber=${searchLatest.transactionNumber}`;
    }

    if (searchLatest.shippingUnit.length > 0) {
      url += `&ShippingUnit=${searchLatest.shippingUnit}`;
    }

    if (searchLatest.attribute47) {
      url += `&Attribute47=1`;
    }

    if (searchLatest.isPackage) {
      url += `&IsPackage=${searchLatest.isPackage}`;
    }

    if (keySearchLatest && keySearchLatest.length > 0) {
      url += `&KeySearch=${keySearchLatest}`;
    }

    try {
      let urlPrefix = generateUrlPrefix(typeGet);
      const response = await repositoryDelivery.get(`${urlPrefix}${url}`);
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();

        if (noti) {
          NotificationExtension.Success(noti);
        }
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      if (dataTblDeliveryStatusSelect) setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...searchLatest,
          keySearch: keySearchLatest,
          valueTypeGet: valueTypeGetLatest,
        }),
      );
    }

    function generateUrlPrefix(typeGet?: string) {
      let urlPrefix = "/api/v1/TblDelivery/get-list";
      const checkType = typeGet ? typeGet : valueTypeGetLatest;
      switch (checkType) {
        case "1":
          urlPrefix = urlPrefix + "-gv";
          break;
        case "2":
          urlPrefix = urlPrefix + "-ktkt";
          break;
        case "3":
          urlPrefix = urlPrefix + "-da";
          break;
        case "4":
          urlPrefix = urlPrefix + "-kttc";
          break;
        case "5":
          urlPrefix =
            urlPrefix.split("/").slice(0, 4).join("/") + "/get-all-gv";
          break;
        default:
          break;
      }
      return urlPrefix;
    }
  };

  const handleExportData = async () => {
    open();
    try {
      const getName = typeGv.find((x) => x.value === valueTypeGet)?.label;
      let url =
        `/api/v1/TblDelivery/export-deliveries?Skip=${
          pagination?.pageIndex * pagination?.pageSize
        }&Take=${pagination.pageSize}&DeliveryDepartment=` + getName;

      if (search.startDate) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.statusId.length > 0) {
        url += search.statusId.map((item: any) => `&StatusId=${item}`).join("");
      }

      if (search.branchId.length > 0) {
        url += search.branchId.map((item: any) => `&BranchId=${item}`).join("");
      }

      if (search.customerId) {
        url += `&CustomerId=${search.customerId}`;
      }

      if (search.sourceType.length > 0) {
        url += search.sourceType
          .map((item: any) => `&SourceType=${item}`)
          .join("");
      }

      if (search.sourceCode) {
        url += `&SourceCode=${search.sourceCode}`;
      }

      if (search.transactionNumber) {
        url += `&TransactionNumber=${search.transactionNumber}`;
      }

      if (search.shippingUnit.length > 0) {
        url += `&ShippingUnit=${search.shippingUnit}`;
      }

      if (search.attribute47) {
        url += `&Attribute47=1`;
      }

      if (search.isPackage) {
        url += `&IsPackage=${search.isPackage}`;
      }

      if (keySearch && keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_muc_don_giao_hang_dieu_van" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleCancelDelivery = async (id: any, type: string) => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDelivery/cancel-deliveries",
      {
        ids: id,
        type: type,
      },
    );

    if (res) {
      if (type === "HUY_PHAN_CONG") {
        NotificationExtension.Success("Hoàn tất hủy phân công !");
      } else {
        NotificationExtension.Success("Hoàn tất hủy đơn hàng !");
      }
      setTimeout(() => {
        modals.closeAll();
        setDeleteViewStatus(!deleteViewStatus);
      }, 1000);
    }
  };

  const handlePushOrder = async () => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/OrderHeader/push-order-header-to-delivery",
      {
        orderCode: orderCode,
      },
    );

    if (res && res.success) {
      setOrderCode("");
      NotificationExtension.Success("Đã cập nhật đơn giao hàng !");
      setTimeout(() => {
        fetchData();
      }, 1000);
    }
  };

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  const height = useDynamicHeight(370);

  useEffect(() => {
    if (valueTypeGet && valueTypeGet.length > 0) {
      fetchData();
    }
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    deleteViewStatus,
    valueTypeGet,
  ]);

  useEffect(() => {
    dataDeliveryStatusSelect();
  }, []);

  const deferredValueselectIds = useDeferredValue(selectIds);
  useEffect(() => {
    startTransition(() => {
      const numericIds = deferredValueselectIds.map((id) => Number(id));

      const filtered = data.filter((item) =>
        numericIds.includes(Number(item.id)),
      );

      setDataDeliverySelect(filtered);
    });
  }, [deferredValueselectIds]);

  const columnVirtualizerInstanceRef = useRef<MRT_ColumnVirtualizer>(null);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem("columnPinningDelivery");
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers", "sourceCode"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningDelivery",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    columnVirtualizerInstanceRef, //optional
    columnVirtualizerOptions: { overscan: 2 }, //optionally customize the virtualizer
    enableColumnResizing: true,
    // enableColumnVirtualization: true,
    enableClickToCopy: true,
    enableTopToolbar: false,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    enableExpandAll: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: (row) =>
      row.original.deliveryStatusName === "Lập đơn giao hàng" ||
      row.original.deliveryStatusName === "Hủy phân công" ||
      row.original.deliveryStatusName ===
        "Đơn hàng giao chưa thành công do Khách hàng" ||
      row.original.deliveryStatusName ===
        "Đơn hàng giao chưa thành công do Hacom" ||
      row.original.deliveryStatusName === "Nối chuyến",
    getRowId: (row) => row.id,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: getColumnVisibility(valueTypeGet),
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height / 1.15, minHeight: height / 1.15 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style:
        String(row.original.attribute47) === "1" ||
        String(row.original.shippingPriority) === "1"
          ? {
              fontWeight: 550, // conditional styling
              fontSize: "11.5px",
              padding: "6px 8px",
              color: "red",
            }
          : styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["15", "25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        detailProduct(
          row.original.id,
          row.original.sourceType,
          row.original.sourceCode,
        );
      },
      sx: { cursor: "pointer" },
    }),
  });
  useHotkeys([["Enter", async () => await fetchData()]]);
  const memoizedProductDetails = React.useMemo(() => {
    return {
      id: productDetails.id,
      sourceType: productDetails.sourceType,
      sourceCode: productDetails.sourceCode,
    };
  }, [productDetails.id, productDetails.sourceType, productDetails.sourceCode]);

  React.useEffect(() => {
    const newColumnVisibility = getColumnVisibility(valueTypeGet ?? "");
    if (table) {
      table.setColumnVisibility(newColumnVisibility);
    }
  }, [valueTypeGet, table]);

  return (
    <>
      {/* {toPageDetail ? (
        <DetailDataView id={detailViewId} handleDetail={handleDetail} />
      ) : toPageEdit && editViewId ? (
        <EditDataView id={editViewId} handleEdit={handleEdit} />
      ) : toPageCreate ? (
        <CreateDataView
          handleCreate={handleCreate}
          setSearch={setSearch}
          department={"NV điều vận"}
        />
      ) : (
        <> */}
      <div ref={headerRef} style={{ width: "100%" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex wrap={"wrap"} justify={"space-between"}>
          <_breadcrumb></_breadcrumb>
          <Flex
            gap="md"
            justify={{ sm: "flex-end", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Menu shadow="md" width={200} closeOnItemClick={false}>
              <Menu.Target>
                <Button
                  leftSection={<IconClipboardPlus size={14} />}
                  color="green"
                  variant="outline"
                  disabled={valueTypeGet === "5"}
                >
                  Đẩy đơn hàng về giao vận
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>
                  Lưu ý: Chỉ sử dụng trong trường hợp đơn hàng đã hoàn thành
                  nhưng không được đẩy sang giao vận để đi giao !
                </Menu.Label>
                <Box mx={10}>
                  <TextInput
                    placeholder="Nhập mã đơn hàng"
                    value={orderCode}
                    onChange={(e) => setOrderCode(e.currentTarget.value)}
                  />
                  <Button
                    variant="filled"
                    color="green"
                    mt={10}
                    w={"100%"}
                    onClick={() => handlePushOrder()}
                  >
                    Đẩy đơn hàng
                  </Button>
                </Box>
              </Menu.Dropdown>
            </Menu>

            {/* <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                // handleCreate();

                modals.openConfirmModal({
                  title: (
                    <>
                      <Title order={5}>Thêm mới !</Title>
                    </>
                  ),
                  size: "auto",
                  children: (
                    <CreateDataView
                      handleCreate={handleCreate}
                      setSearch={setSearch}
                      department={
                        String(getValueById(valueTypeGet, typeGv, "label"))
                          .length > 0
                          ? getValueById(valueTypeGet, typeGv, "label")
                          : "NV điều vận"
                      }
                      load={fetchData}
                    />
                  ),
                  confirmProps: { display: "none" },
                  cancelProps: { display: "none" },
                });
              }}
            >
              Tạo mới (F11)
            </Button> */}
            <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              disabled={valueTypeGet === "5"}
              onClick={() => {
                // handleCreate();

                modals.openConfirmModal({
                  title: (
                    <>
                      <Title order={5}>Thêm mới đơn giao hàng thủ công !</Title>
                    </>
                  ),
                  size: "90vw",
                  children: (
                    <CreateDataViewV2
                      department={
                        String(getValueById(valueTypeGet, typeGv, "label"))
                          .length > 0
                          ? getValueById(valueTypeGet, typeGv, "label")
                          : "NV điều vận"
                      }
                      onSuccess={fetchData}
                    />
                  ),
                  confirmProps: { display: "none" },
                  cancelProps: { display: "none" },
                });
              }}
            >
              Tạo mới
            </Button>
            <Menu shadow="md" width={225}>
              <Menu.Target>
                <Button
                  leftSection={
                    <IconTruck style={{ width: rem(14), height: rem(14) }} />
                  }
                  color="purple"
                  disabled={
                    deferredValueselectIds.length < 1 ||
                    !valueTypeGet ||
                    String(valueTypeGet).length === 0 ||
                    valueTypeGet === "5"
                  }
                >
                  Phân công
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item
                  leftSection={
                    <IconTruck style={{ width: rem(14), height: rem(14) }} />
                  }
                  onClick={() => {
                    if (checkAtt6()) {
                      modalDeliveryAssignment("GIAO_HANG");
                    } else {
                      NotificationExtension.Fails(
                        "Vui lòng đổi địa chỉ các đơn hàng nối chuyến !",
                      );
                    }
                  }}
                  disabled={deferredValueselectIds.length < 1}
                >
                  {valueTypeGet === "4"
                    ? "Phân công giao hàng lắp đặt"
                    : "Phân công giao hàng"}
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconTruckReturn
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={() => {
                    if (handleTransfer() && checkAtt6()) {
                      modalDeliveryAssignment("NOI_CHUYEN");
                    } else {
                      NotificationExtension.Fails(
                        "Vui lòng đổi địa chỉ đơn hàng trước khi phân công nối chuyến !",
                      );
                    }
                  }}
                  disabled={
                    deferredValueselectIds.length !== 1 || valueTypeGet === "4"
                  }
                >
                  Phân công nối chuyến
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconTruckDelivery
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  disabled={deferredValueselectIds.length < 2}
                  onClick={() => {
                    modalDeliveryAssignment("GHEP_DON");
                  }}
                >
                  Phân công ghép đơn
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconPackage style={{ width: rem(14), height: rem(14) }} />
                  }
                  disabled={
                    deferredValueselectIds.length < 1 || valueTypeGet === "4"
                  }
                  onClick={() => {
                    modalDeliveryAssignment("DONG_GOI");
                  }}
                >
                  Phân công đóng gói đi GHTK
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={() => handleExportData()}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Import Excel
                  </Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
        <Flex gap={"md"} align={"center"} wrap={"wrap"} mb={10} mt={10}>
          <Grid gutter={"xs"} w={"100%"}>
            <Grid.Col span={sizeGrid}>
              <TextInput
                placeholder="Nhập từ khóa"
                defaultValue={keySearch}
                leftSection={<IconSearch color="#15aabf" />}
                onChange={(e) => setKeySearch(e.currentTarget.value)}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Từ ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                value={
                  search.startDate.length > 0
                    ? new Date(search.startDate ?? "")
                    : null
                }
                onChange={(e) => {
                  handleChangeSearchValue(
                    e ? formatDateNotTimeZone(e ?? "") : "",
                    "startDate",
                  );
                }}
                leftSection={<IconCalendar color="#15aabf" />}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Đến ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                value={
                  search.endDate.length > 0
                    ? new Date(search.endDate ?? "")
                    : null
                }
                onChange={(e) => {
                  handleChangeSearchValue(
                    e ? formatDateNotTimeZone(e ?? "") : "",
                    "endDate",
                  );
                }}
                leftSection={<IconCalendar color="#15aabf" />}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Chi nhánh - Địa điểm nhận hàng"
                data={dataBranchSelect
                  ?.filter((i) =>
                    valueTypeGet === "1" ? i.attr6 !== "DVT" : true,
                  )
                  ?.map((i) => ({
                    label: `${i.att2} - ${i.text}`,
                    value: String(i.value),
                  }))}
                value={
                  search?.branchId && search?.branchId.length > 0
                    ? search?.branchId
                    : []
                }
                leftSection={<IconBrandBootstrap color="#15aabf" />}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                onChange={(e) => {
                  handleChangeSearchValue(e ? e : [], "branchId");
                }}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Nguồn hàng"
                data={[
                  { label: "Đơn hàng", value: "1" },
                  { label: "Điều chuyển", value: "2" },
                  { label: "Khác", value: "3" },
                  { label: "Xuất bảo hành", value: "4" },
                  { label: "Xuất trả khách", value: "5" },
                ]}
                value={
                  search?.sourceType && search?.sourceType.length > 0
                    ? search?.sourceType
                    : []
                }
                leftSection={<IconPackageExport color="#15aabf" />}
                onChange={(e) =>
                  handleChangeSearchValue(e ? e : [], "sourceType")
                }
                clearable
                renderOption={renderSelectOptionSourceType}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Trạng thái"
                clearable
                data={dataTblDeliveryStatusSelect}
                value={
                  search?.statusId && search?.statusId.length > 0
                    ? search?.statusId
                    : []
                }
                leftSection={<IconStatusChange color="#15aabf" />}
                onChange={(e) => {
                  handleChangeSearchValue(e ? e : [], "statusId");
                }}
                renderOption={renderSelectOptionStatus}
                comboboxProps={{ width: 400 }}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                placeholder="Bộ phận"
                // defaultValue={keySearch}
                leftSection={<IconSearch color="#15aabf" />}
                data={typeGv}
                value={valueTypeGet?.toString()}
                onChange={(e) => setValueTypeGet(e ? e : "")}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                placeholder="Đơn vị vận chuyển"
                clearable
                data={dataShippingUnit}
                value={search?.shippingUnit}
                leftSection={<IconTruck color="#15aabf" />}
                renderOption={renderSelectOptionShippingUnit}
                onChange={(e) =>
                  handleChangeSearchValue(e ? e : "", "shippingUnit")
                }
              />
            </Grid.Col>
            {/* <Grid.Col span={sizeGrid}>
              <Select
                placeholder="Tình trạng đóng gói"
                leftSection={<IconPackage color="#15aabf" />}
                clearable
                data={isPackTheGoods}
                value={search?.isPackage}
                onChange={(e) =>
                  handleChangeSearchValue(e ? e : "", "isPackage")
                }
              />
            </Grid.Col> */}
            <Grid.Col span={sizeGrid}>
              <Flex gap={"md"} align={"center"}>
                <Checkbox
                  label="Đơn hỏa tốc"
                  checked={search.attribute47}
                  onClick={() =>
                    setSearch((prev) => ({
                      ...prev,
                      attribute47: !search.attribute47,
                    }))
                  }
                />
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={() => {
                    fetchData();
                  }}
                  disabled={
                    isPending ||
                    !valueTypeGet ||
                    String(valueTypeGet).length === 0
                  }
                >
                  Tìm kiếm
                </Button>
              </Flex>
            </Grid.Col>
          </Grid>
        </Flex>
      </div>
      <MantineReactTable table={table} />
      <Box mt={5}>
        <DetailProduct
          id={memoizedProductDetails.id}
          sourceType={memoizedProductDetails.sourceType}
          sourceCode={memoizedProductDetails.sourceCode}
          isDetail={false}
        />
      </Box>
      {/* </>
      )} */}
    </>
  );
};

export default Delivery2;
